import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';

type BackButtonProps = {
  link: string;
  label?: string;
  variant?: 'default' | 'subtle';
};

export function BackButton({
  link,
  label = 'Go back',
  variant = 'default',
}: BackButtonProps) {
  const navigate = useNavigate();

  if (variant === 'subtle') {
    return (
      <button
        type="button"
        onClick={() => navigate(link)}
        className="inline-flex items-center gap-1.5 text-sm text-neut-sec hover:text-neut-prim transition-colors w-fit cursor-pointer"
      >
        <ArrowLeft size={14} aria-hidden="true" />
        {label}
      </button>
    );
  }

  return (
    <button
      onClick={() => navigate(link)}
      className="flex items-center gap-2 p-2 hover:bg-neutral-100 rounded-lg transition-colors cursor-pointer"
    >
      <ArrowLeft className="w-5 h-5" aria-hidden="true" />
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
